import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  SectionAddPayload,
  SectionsUpdatePayload,
} from '../sections/sections.interface';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsService {
  private token!: string;
  private httpOptions: any;

  // private basePath = environment.interop.basePath
  // private getSectionDT = this.basePath + environment.interop.urbanism.nomenclatoare.section.getSectionsDT
  // private token!: string
  // private httpOptions: any;
  // private storeSectionURL = this.basePath + environment.interop.urbanism.nomenclatoare.section.storeSection;
  // private updateStoreSection = this.basePath + environment.interop.urbanism.nomenclatoare.section.putSection;
  // private deleteStoreSection = this.basePath + environment.interop.urbanism.nomenclatoare.section.deleteSection;
  // private getSectionsActive = this.basePath + environment.interop.urbanism.nomenclatoare.section.getSectionsActive;
  // private getSectionsPublic = this.basePath + environment.interop.urbanism.nomenclatoare.section.getSectionsActivePublic;

  constructor(private http: HttpClient) {}

  getDepartmentDT() {}

  addDepartment(section: SectionAddPayload) {}

  updateDepartment(section: SectionsUpdatePayload) {}

  deleteDepartment(sectionId: number) {}

  getActiveDepartment() {}

  getPublicDepartment() {}

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
